import React from "react";
import { ShimmerPostList, ShimmerSimpleGallery } from "react-shimmer-effects";

const SpaceShimmer = ({ row = 1, col = 3, height = 400 }) => {
  return (
    <>
      <div className="space_shimmer">
        <ShimmerPostList
          postStyle="STYLE_FOUR"
          gap={30}
          col={col}
          row={row}
          imageHeight={80}
        />
      </div>
    </>
  );
};

export default SpaceShimmer;
